import React from 'react'

import {
  SessionContext,
  SessionContextType,
} from 'stores/session/SessionContext'

const withSessionContext = <T extends React.ComponentClass<any, any>>(
  Component: T
): T => {
  Component.contextType = SessionContextType
  return Component
}

export default withSessionContext
export { SessionContext }
